import { requestApi } from '@app/api';
import { withUpload } from '@app/api/paths';

export interface CheckUploadedFileFormat {
  isValidFileFormat: boolean;
}

export function checkIsUploadedFileValid(fileId: string, otp: string) {
  return requestApi<CheckUploadedFileFormat>({
    url: withUpload(`/documents/file-hashes/${fileId}`),
    method: 'GET',
    params: {
      otp,
    },
  });
}
